for(const el of document.querySelectorAll('[type="checkbox"]')) {
  el.addEventListener('input', (e) => {

    //el[el.checked?'setAttribute':'removeAttribute']('checked');

    if (el.checked) {
      el.setAttribute('checked', '');
    } else {
      el.removeAttribute('checked');

    }

  });
}
